module.exports = __webpack_public_path__ + "static/media/Quiche-Flare-Thin-Italic.1c047af7.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Quiche-Flare-Thin-Italic.eot
// module id = 2888
// module chunks = 71